import type { ThemeProviderProps } from "next-themes";
import { ThemeProvider as NextThemeProvider } from "next-themes";

// next-themes is this package's dependency, so apps read the hook from here
// rather than declaring it themselves.
export { useTheme } from "next-themes";

// next-themes injects an inline <script> to prevent FOUC.
// React 19 warns about <script> inside client components even though
// the script runs correctly during SSR. Suppress this false-positive
// until next-themes ships a fix (pacocoursey/next-themes#385).
if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  const _origConsoleError = console.error;
  console.error = (...args: unknown[]) => {
    if (
      typeof args[0] === "string" &&
      (args[0].includes("Encountered a script tag") ||
        args[0].includes("a component that hasn't mounted yet"))
    ) {
      return;
    }

    _origConsoleError.apply(console, args);
  };
}

/**
 *
 */
export const ThemeProvider = ({
  children,
  ...properties
}: ThemeProviderProps) => (
  <NextThemeProvider attribute="class" defaultTheme="light" {...properties}>
    {children}
  </NextThemeProvider>
);
